define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/my-profile/myProfileView.tmpl");
    var Button = require("ui/button/Button");
    var Bubble = require("ui/bubble/Bubble");
    var GeneralUtilities = require("infra-util/GeneralUtilities");
    var DomUtilities = require("infra-util/DomUtilities");
    var InputField = require("ui/input-field/InputField");
    var Dropdown = require("ui/dropdown/Dropdown");
    var SettingsCollection = require("collections/SettingsCollection");
    var Settings = require("codeTables/settings.json");
    var RETYPE_PASSWORD_ERROR_KEY = "retypePassword";
    var ProfileModel = require("models/entities/ProfileModel");

    var that;

    var MyProfileView = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        MyProfileView = Marionette.ItemView.extend({

            template : template,
            className : "my-profile-dialog-container",
            withUIComponents : true,

            events: {
                "click .roles-info .roles-title": "_onRolesClick"
            },

            ui: {
                loginNameDiv: ".login-name",
                emailDiv: ".email",
                nicknameDiv: ".nickname",
                nameDiv: ".name",
                currPasswordDiv: ".curr-password",
                newPasswordDiv: ".new-password",
                retypeNewPasswordDiv: ".retype-new-password",
                languageDiv: ".language",
                timeZoneDiv: ".time-zone",
                rolesDiv: ".curr-roles",
                rolesInfo: ".roles-info",
                manageGroupsDiv: ".manage-groups",
                lineOfBusinessDiv: ".line-of-business",

                btnSave: ".button-save",
                btnCancel: ".button-cancel"
            },

            uiComponents: {
                loginNameInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.loginNameDiv",
                        disabled: true
                    }
                },
                emailInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.emailDiv",
                        placeholder: LE.translator.translate("LEUserManagement.also.login.name.new")
                    }
                },
                nickNameInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.nicknameDiv",
                        disabled: true
                    }
                },
                nameInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.nameDiv",
                        disabled: "view._isNameInputDisabled"
                    }
                },
                currPasswordInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.currPasswordDiv",
                        type: InputField.Type.Password,
                        placeholder: LE.translator.translate("LEUserManagement.curr.placeholder")
                    }
                },
                newPasswordInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.newPasswordDiv",
                        type: InputField.Type.Password
                    }
                },
                retypeNewPasswordInput: {
                    type: InputField,
                    options: {
                        el:"view.ui.retypeNewPasswordDiv",
                        type: InputField.Type.Password
                    }
                },

                language: {
                    type: Dropdown,
                    options: {
                        name: "language",
                        selectedOption: "view._getSelectedLanguage",
                        items: "view._getLanguageOptions",
                        container: "view.ui.languageDiv"
                    }
                },

                timeZone: {
                    type: Dropdown,
                    options: {
                        name: 'timezone',
                        selectedOption: "view._getSelectedTimeZone",
                        items: "view._getTimeZoneOptions",
                        container: "view.ui.timeZoneDiv"
                    }
                },

                btnCancel: {
                    type: Button,
                    options: {
                        el: "view.ui.btnCancel",
                        permutation:Button.PERMUTATION.LINK,
                        onClick: onCancelButtonClicked
                    }
                },
                btnSave: {
                    type: Button,
                    options: {
                        el: "view.ui.btnSave",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        onClick: onSaveButtonClicked
                    }
                }
            },

            customTemplateHelpers: function() {
                var hasProfileFeature = LE.sessionManager.hasProfilesFeature();
                var hasManageGroups =  hasProfileFeature && this.model.getManagerOfGroup() && this.model.getManagerOfGroup().length;
                var rolesAndProfiles = hasProfileFeature && this._getRolesAndProfiles() || [];
                var managerOf = hasManageGroups && this._getManagerOf() || "";

                return {
                    hasProfileFeature: hasProfileFeature,
                    hasManageGroups:  hasManageGroups,
                    rolesAndProfiles: rolesAndProfiles,
                    managerOf: managerOf
                };
            },

            initialize: function (options) {
                LEManager.logger.info("MyProfileView >> initialize >> START");
                this.settingsCollection = options.settingsCollection;
                this.model = options.model;
                this.channel = LEManager.media.channel("myProfile");
                this.RoleGroupOrder = [
                    ProfileModel.ROLES.AGENT,
                    ProfileModel.ROLES.AGENT_MANAGER,
                    ProfileModel.ROLES.CAMPAIGN_MANAGER,
                    ProfileModel.ROLES.ADMINISTRATOR
                ];
                LEManager.logger.info("MyProfileView >> initialize >> END");
            },

            onRender: function() {
                that = this;

                this.listenTo(this, "page:closeButtonClick", onCancelButtonClicked);
                that.uiComponents.loginNameInput.setValue(that.model.getLoginName());
                that.uiComponents.emailInput.setValue(that.model.getEmail());
                that.uiComponents.nickNameInput.setValue(that.model.getNickName());
                that.uiComponents.nameInput.setValue(that.model.getDisplayName());
                this.listenTo(this.channel.vent, "profile:save:error", this._onSaveError);
            },

            onInvalid: function(model, errors) {
                LEManager.logger.info("MyProfileView >> onInvalid >> START");
                LEManager.notifier.showError({content : LE.translator.translate("LEFramework.errors.generalError.on.page"), container : ".work-area-wrapper"});
                cleanAllErrorBubbles();
                setAllErrorBubbles(errors);
                LEManager.logger.info("MyProfileView >> onInvalid >> END");
            },

            onBeforeClose : function () {
                this.uiComponents.btnCancel.close();
                this.uiComponents.btnSave.close();
                return true;
            },

            onClose:function () {
                LEManager.logger.info("closing","MyProfileView:onClose");
            },

            _isNameInputDisabled: function() {
                var isDisabled = (this.settingsCollection.get(Settings.SETTING_ID.MY_DETAILS_BLOCK_NAME_CHANGE).getValue() === "true");
                return isDisabled;
            },

            _getRolesAndProfiles: function() {
                LEManager.logger.info("MyProfileView >> _getRolesAndProfiles >> START");
                var fullProfiles = this.model.getFullProfiles();
                var rolesAndProfiles = [];

                if (fullProfiles && fullProfiles.length) {
                    fullProfiles.sort(_.bind(function(a, b) {
                        var indexA = this.RoleGroupOrder.indexOf(a.roleTypeId.toString());
                        var indexB = this.RoleGroupOrder.indexOf(b.roleTypeId.toString());

                        if (indexA < indexB) {
                            return -1;
                        }

                        if (indexA > indexB) {
                            return 1;
                        }

                        // indexes must be equal
                        return 0;
                    }, this));
                    _.each(fullProfiles, function(item, index) {
                        rolesAndProfiles.push({ name: LE.translator.translate(ProfileModel.ROLES_BY_IDS[item.roleTypeId]) + " - " + item.name });
                    }, this);
                }

                LEManager.logger.info("MyProfileView >> _getRolesAndProfiles >> END");
                return rolesAndProfiles;
            },

            _getManagerOf: function() {
                LEManager.logger.info("MyProfileView >> _getManagerOf >> START");
                var managedAgentGroups = this.model.getManagedAgentGroups();
                var managedGroups = "";

                if (managedAgentGroups && managedAgentGroups.length) {
                    _.each(managedAgentGroups, function(item, index) {
                        managedGroups += item.name;

                        if (index < (managedAgentGroups.length - 1)) {
                            managedGroups += ", ";
                        }
                    }, this);
                }

                LEManager.logger.info("MyProfileView >> _getManagerOf >> END");
                return managedGroups;
            },

            _getLanguageOptions: function() {
                LEManager.logger.info("MyProfileView >> _getLanguageOptions >> START");
                var languageList = LE.siteSettings.languageSettings.getLanguageListTranslated();
                LEManager.logger.info("MyProfileView >> _getLanguageOptions >> END");
                return new Dropdown.Collection(languageList);
            },

            _getSelectedLanguage: function() {
                LEManager.logger.info("MyProfileView >> _getSelectedLanguage >> START / END");
                var selectedLanguageModel = this.settingsCollection.get(Settings.SETTING_ID.LOCALE);
                if(selectedLanguageModel) {
                    return selectedLanguageModel.getValue();
                } else {
                    LEManager.logger.info("MyProfileView >> _getSelectedLanguage >> selectedLanguageModel not exists");
                }
            },

            _getTimeZoneOptions: function() {
                LEManager.logger.info("MyProfileView >> _getTimeZoneOptions >> START");
                var timeZoneList = LE.siteSettings.timeZoneSettings.getTimeZoneListTranslated();
                _.each(timeZoneList, function(item){
                    item.searchKey = item.value.substring(12,item.value.length).trim().toLowerCase();
                });
                LEManager.logger.info("MyProfileView >> _getTimeZoneOptions >> END");
                return new Dropdown.Collection(timeZoneList);
            },

            _getSelectedTimeZone: function() {
                LEManager.logger.info("MyProfileView >> _getSelectedTimeZone >> START / END");
                var selectedTimeZoneModel = this.settingsCollection.get(Settings.SETTING_ID.TIME_ZONE);
                if(selectedTimeZoneModel) {
                    return selectedTimeZoneModel.getValue();
                } else {
                    LEManager.logger.info("MyProfileView >> _getSelectedTimeZone >> selectedTimeZoneModel not exists");
                }
            },

            _onSaveError: function(errors) {
                this._hideErrors();

                this.errorsOnPage = errors;
                var KEYS = this.model.getKeys();
                var errorCodes = this.model.getErrorCodes();

                if (_.has(errors, KEYS.EMAIL_ADDRESS)) {
                    this.uiComponents.emailInput.setError(true, errors[KEYS.EMAIL_ADDRESS]);
                }

                if (_.has(errors, KEYS.NICK_NAME)) {
                    this.uiComponents.nickNameInput.setError(true, errors[KEYS.NICK_NAME]);
                }

                if (_.has(errors, KEYS.DISPLAY_NAME)) {
                    this.uiComponents.nameInput.setError(true, errors[KEYS.DISPLAY_NAME]);
                }

                if (_.has(errors, RETYPE_PASSWORD_ERROR_KEY)) {
                    this.uiComponents.retypeNewPasswordInput.setError(true, errors[RETYPE_PASSWORD_ERROR_KEY]);
                    this.uiComponents.newPasswordInput.setError(true, errors[RETYPE_PASSWORD_ERROR_KEY]);
                }
                if (_.has(errors, KEYS.PASSWORD)) {
                    this.uiComponents.newPasswordInput.setError(true, errors[KEYS.PASSWORD]);
                }

                if (_.has(errors, KEYS.OLD_PASSWORD) && this.uiComponents.currPasswordInput) {
                    this.uiComponents.currPasswordInput.setError(true, errors[KEYS.OLD_PASSWORD]);
                }

                if (_.has(errors, errorCodes.PASSWORD_RESTRICTIONS)) {
                    this.uiComponents.newPasswordInput.setError(true, errors[this.model.ERROR_CODES.PASSWORD_RESTRICTIONS]);
                }
            },

            _hideErrors: function () {
                this.errorsOnPage = null;
                this.uiComponents.emailInput.setError(false);
                this.uiComponents.nickNameInput.setError(false);
                this.uiComponents.nameInput.setError(false);
                this.uiComponents.currPasswordInput.setError(false);
                this.uiComponents.newPasswordInput.setError(false);
                this.uiComponents.retypeNewPasswordInput.setError(false);
            },

            _onRolesClick: function(ev) {
                var rolesInfo = $(ev.currentTarget).parent();
                var rolesContent = rolesInfo.find(".roles-content");

                var add = "closed";
                var remove = "opened";

                if (rolesInfo.hasClass("closed")) {
                    remove = "closed";
                    add = "opened";
                }

                rolesInfo.addClass(add).removeClass(remove);
                rolesContent.addClass(add).removeClass(remove);
            }
        });

        function onCancelButtonClicked(){
           that.trigger(MyProfileView.TRIGGERING.CANCEL_BUTTON_CLICKED);
        }

        function onSaveButtonClicked(){
            LEManager.logger.info("START", "MyProfileView: onSaveButtonClicked");
            var errors = doValidate();

            if (errors){
                LEManager.logger.info("MyProfileView >> onSaveButtonClicked >> validation failure");
                that.onInvalid(null, errors);
            } else {
                var language = that.uiComponents.language.getValue();
                var timeZone = that.uiComponents.timeZone.getValue();

                that.trigger(MyProfileView.TRIGGERING.SAVE_BUTTON_CLICKED, { userData: componentsToJson(), language: language, timeZone: timeZone});

                LEManager.logger.info("MyProfileView >> onSaveButtonClicked >> saveButton click triggered");
            }
        }

        function componentsToJson(){
            var profile = {};
            profile[MyProfileView.MODEL.FIELDS.LOGIN_NAME] = that.uiComponents.loginNameInput.getValue();
            profile[MyProfileView.MODEL.FIELDS.EMAIL_ADDRESS] = that.uiComponents.emailInput.getValue();
            profile[MyProfileView.MODEL.FIELDS.NICK_NAME] = that.uiComponents.nickNameInput.getValue();
            profile[MyProfileView.MODEL.FIELDS.DISPLAY_NAME] = that.uiComponents.nameInput.getValue();
            profile[MyProfileView.MODEL.FIELDS.OLD_PASSWORD] = that.uiComponents.currPasswordInput.getValue();
            profile[MyProfileView.MODEL.FIELDS.PASSWORD] = that.uiComponents.newPasswordInput.getValue();
            return profile;
        }


        ////////////////////
        // ERROR HANDLING //
        ////////////////////

        function cleanAllErrorBubbles(){
            LEManager.logger.info("MyProfileView >> cleanAllErrorBubbles >> START");
            for(var component in COMPONENTS) {
                that.uiComponents[COMPONENTS[component]].setError(false);
            }
            LEManager.logger.info("MyProfileView >> cleanAllErrorBubbles >> END");
        }

        function setAllErrorBubbles(errors){
            LEManager.logger.info("MyProfileView >> setAllErrorBubbles >> START");
            for(var error in errors) {
                if(ERRORS[error]) {
                    that.uiComponents[ERRORS[error].component].setError(true, LE.translator.translate(ERRORS[error].textKey));
                } else {
                    LEManager.logger.info("MyProfileView >> setAllErrorBubbles >> Error not exists in ERRORS -> " + error);
                }
            }
            LEManager.logger.info("MyProfileView >> setAllErrorBubbles >> END");
        }

        function validateNickname(){
            LEManager.logger.info("MyProfileView >> validateNickname >> START");
            var errors = {};
            if (LE.utilities.validation.isEmpty(that.uiComponents.nickNameInput.getValue()) ) {
                errors[ERROR_IDS.NICKNAME_EMPTY] = true;
            }
            LEManager.logger.info("MyProfileView >> validateNickname >> END");
            return errors;
        }

        function validateEmail(){
            LEManager.logger.info("MyProfileView >> validateEmail >> START");
            var errors = {};
            if (LE.utilities.validation.isEmpty(that.uiComponents.emailInput.getValue()) ) {
                errors[ERROR_IDS.EMAIL_EMPTY] = true;
            } else if(_.isNull(that.uiComponents.emailInput.getValue().match(Backbone.Validation.patterns.email))) {
                errors[ERROR_IDS.EMAIL_INVALID] = true;
            }
            LEManager.logger.info("MyProfileView >> validateEmail >> END");
            return errors;
        }

        function validatePassword(){
            LEManager.logger.info("MyProfileView >> validatePassword >> START");
            var errors = {};
            if (!LE.utilities.validation.isPasswordValid(that.uiComponents.newPasswordInput.getValue())) {
                errors[ERROR_IDS.PASSWORD_LENGTH] = true;
            }
            LEManager.logger.info("MyProfileView >> validatePassword >> END");
            return errors;
        }

        function validateConfirmPassword(){
            LEManager.logger.info("MyProfileView >> validateConfirmPassword >> START");
            var errors = {};
            if ( that.uiComponents.newPasswordInput.getValue() !== that.uiComponents.retypeNewPasswordInput.getValue() ) {
                errors[ERROR_IDS.PASSWORD_MATCH] = true;
            }
            LEManager.logger.info("MyProfileView >> validateConfirmPassword >> END");
            return errors;
        }

        function validateCurrentPassword(){
            LEManager.logger.info("MyProfileView >> validateCurrentPassword >> START");
            var errors = {};
            if ( LE.utilities.validation.isEmpty(that.uiComponents.currPasswordInput.getValue()) ) {
                if (!LE.utilities.validation.isEmpty(that.uiComponents.newPasswordInput.getValue()) || !LE.utilities.validation.isEmpty(that.uiComponents.retypeNewPasswordInput.getValue())){
                    errors[ERROR_IDS.CURR_PASSWORD_EMPTY] = true;
                }
            }
            LEManager.logger.info("MyProfileView >> validateCurrentPassword >> END");
            return errors;
        }

        function validateAllPasswordCases(){
            LEManager.logger.info("MyProfileView >> validateAllPasswordCases >> START");
            var errors = {};
             _.extend(errors, validateCurrentPassword());

            if ( LE.utilities.validation.isEmpty(that.uiComponents.newPasswordInput.getValue()) ) {
                if ( !LE.utilities.validation.isEmpty(that.uiComponents.retypeNewPasswordInput.getValue()) ) {
                    errors[ERROR_IDS.PASSWORD_EMPTY] = true;
                }
            }else {
                _.extend(errors, validatePassword());
            }
            LEManager.logger.info("MyProfileView >> validateAllPasswordCases >> END");
            return errors;
        }

        function doValidate(){
            LEManager.logger.info("MyProfileView >> doValidate >> START");
            var errors = {};
            _.extend(errors, validateNickname());
            _.extend(errors, validateEmail());
            _.extend(errors, validateAllPasswordCases());
            _.extend(errors, validateConfirmPassword());
            if (_.isEmpty(errors)){
                return false;
            }else{
                return errors;
            }
            LEManager.logger.info("MyProfileView >> doValidate >> END");
        }

        MyProfileView.MODEL = {
            FIELDS: {
                DISPLAY_NAME: "displayName",
                NICK_NAME: "nickName",
                LOGIN_NAME: "loginName",
                EMAIL_ADDRESS: "email",
                MAX_NUMBER_OF_CHATS: "maxNumberOfChats",
                SKILLS: "skills",
                OLD_PASSWORD: "oldPassword",
                PASSWORD: "password",
                LANGUAGE: "language",
                TIME_ZONE: "timeZone"
            }
        };

        var COMPONENTS = {
            EMAIL_INPUT: "emailInput",
            NAME_INPUT: "nameInput",
            NICKNAME_INPUT: "nickNameInput",
            CURR_PASSWORD_INPUT: "currPasswordInput",
            PASSWORD_INPUT: "newPasswordInput",
            RETYPE_PASSWORD_INPUT: "retypeNewPasswordInput"
        };


        var ERROR_IDS = {
            NICKNAME_EMPTY: "nicknameEmpty",
            PASSWORD_EMPTY: "passwordEmpty",
            CURR_PASSWORD_EMPTY: "currPasswordEmpty",
            PASSWORD_LENGTH: "passwordLength",
            PASSWORD_MATCH: "passwordMatch",
            WRONG_CREDENTIALS: "wrongCredentials",
            NAME_NOT_UNIQUE: "nameNotUnique",
            EMAIL_EMPTY: "emailEmpty",
            EMAIL_INVALID: "emailInvalid"
        };


        var ERRORS = {};
        ERRORS[ERROR_IDS.NAME_NOT_UNIQUE] = {
            component: COMPONENTS.NAME_INPUT,
            textKey: "LEUserManagement.NameAlreadyExist"
        };

        ERRORS[ERROR_IDS.NICKNAME_EMPTY] = {
            component: COMPONENTS.NICKNAME_INPUT,
            textKey: "LEUserManagement.EnterValidNickname"
        };
        ERRORS[ERROR_IDS.EMAIL_EMPTY] = {
            component: COMPONENTS.EMAIL_INPUT,
            textKey: "LEUserManagement.PleaseEnterRequiredEmail"
        };
        ERRORS[ERROR_IDS.EMAIL_INVALID] = {
            component: COMPONENTS.EMAIL_INPUT,
            textKey: "LEUserManagement.PleaseEnterValidEmail"
        };
        ERRORS[ERROR_IDS.PASSWORD_LENGTH] = {
            component: COMPONENTS.PASSWORD_INPUT,
            textKey: "LEUserManagement.EnterValidPassword"
        };
        ERRORS[ERROR_IDS.PASSWORD_EMPTY] = {
            component: COMPONENTS.PASSWORD_INPUT,
            textKey: "LEUserManagement.PleaseEnterPassword"
        };
        ERRORS[ERROR_IDS.CURR_PASSWORD_EMPTY] = {
            component: COMPONENTS.CURR_PASSWORD_INPUT,
            textKey: "LEUserManagement.EnterCurrentPassword"
        };
        ERRORS[ERROR_IDS.WRONG_CREDENTIALS] = {
            component: COMPONENTS.CURR_PASSWORD_INPUT,
            textKey: "LEUserManagement.WrongCurrentPassword"
        };

        ERRORS[ERROR_IDS.PASSWORD_MATCH] = {
            component: COMPONENTS.RETYPE_PASSWORD_INPUT,
            textKey: "LEUserManagement.PasswordsNotMatch"
        };
    });

    MyProfileView.TRIGGERING = {
        LANGUAGE_CHANGED: "myProfile:languageChanged",
        SAVE_BUTTON_CLICKED: "myProfile:saveButtonClicked",
        CANCEL_BUTTON_CLICKED: "myProfile:cancelButtonClicked"
    };

    return MyProfileView;
});
